export default __webpack_public_path__ + "static/media/SEA_8697.b836a72e.jpg";